import { View } from 'backbone';
import template from 'quick-help-view.ejs';
import util from 'util/Util';
import TourService from 'TourService.js';
import constants from 'Constants';
import listService  from 'ListService';
import AIChatModal from './designer/modals/AIChatModal';
class QuickHelpView extends View {

    initialize(opts) {
        super.initialize(opts);
        this.type = opts.type;
        this.helpLink = opts.helpLink;
        this.template = template;

        let videoId = ""

        switch (this.type) {
            case 'app':
                videoId = constants.HELP_CENTER_FORMS_VID;
                this.title = "App Designer";
                break;
            case 'report':
                videoId = constants.HELP_CENTER_REPORTS_VID;
                this.title = "Report Designer";
                break;
            default: //dashboard
                videoId = constants.HELP_CENTER_DASHBOARD_VID;
                this.title = "Dashboard";
                break;
        }
                
        return this;
    }

    enableSlide() {
        $(".slide-toggle").on('click', () => {

            const opened = $(".opened-help").width() > 0;
            let width = "250px", height = "100%";

            if (opened) {
                width = "0px";
                height = "0px";
                $(".box-inner").hide();
                $(".closed-tag").show();
                $(".opened-tag .tag").hide();
                $(".opened-tag .text").hide();
            }
            else {
                $(".box-inner").show();
                $(".closed-tag").hide();
                $(".opened-tag .tag").show();
                $(".opened-tag .text").show();
            }
          

            $(".opened-tag").animate({
                width: width
            });           

            $(".opened-help").animate({
                width: width
            });

        });
    }

    bindHelpSectionEvents(){
        const self = this;
        $("#QH_helpCenter").on("click", () => {
            self.helpGuide.dialog("open");

            $('.form-designer-video').off().on("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                self.helpGuide.dialog("close");
                this.dashboardVideo = util.newDashboardModal('#quick-help-center-modal-video', {title: 'Get to Know the Dashboard', hideTitleBar:false, closeEsc: true, closeFx: this.stopVideoPlaying});
                self.startVideo();
            });
        });

        $("#QH_AIChatBot").off().on("click", () => {
            const context = self.buildChatContext();
            const isDashboard = self.type === 'dash';

            // If panel is already open on dashboard, just focus input
            if (isDashboard && $('#dashboard-right-panel').is(':visible')) {
                $('#userInput').focus();
                return;
            }

            const mode = isDashboard ? 'panel' : 'dialog';
            const el = isDashboard ? '#AIChatPanelContent' : '#AIChatDiv';
            const aiChatModal = new AIChatModal({
                el: el,
                userContext: context,
                mode: mode,
                contextProvider: isDashboard ? () => self.buildChatContext() : null
            });
            aiChatModal.render();
        });
    }

    bindDashboardEvents(){
        const self = this;

        const dashboardHelp = $("#dashboard");

        const createLI = (text, link) =>{
            const $li = $('<li>'+ text +'</li>');
            dashboardHelp.append($li);

            $li.on("click", ()=>{
                window.open(link, "_blank");
            });
        };

        switch(listService.activeDashboardTab){
            case constants.DASHBOARD_SECTION_REPORTS:
                createLI("Create a Report", constants.HELP_DOCUMENTATION + "hg_qs_creating-a-report.html");
                createLI("Edit a Report", constants.HELP_DOCUMENTATION + "hg_edit_reports.html");
                createLI("View Reports", constants.HELP_DOCUMENTATION + "hg_view_reports.html");
            break;
            case constants.DASHBOARD_SECTION_CONNECTIONS:
                createLI("Create a Connection", constants.HELP_DOCUMENTATION + "hg_connections.html");
                createLI("Defining Connection Actions", constants.HELP_DOCUMENTATION + "hg_defining_connection_actions.html");
            break;
            case constants.DASHBOARD_SECTION_NOTIFICATIONS:
                createLI("Notifications Dashboard", constants.HELP_DOCUMENTATION + "hg_notifications_dashboard.html");
            break;
            case constants.DASHBOARD_SECTION_SETTINGS:
                createLI("Account Settings", constants.HELP_DOCUMENTATION + "hg_account_settings.html");
            break;
            default:
                createLI("Create an App", constants.HELP_DOCUMENTATION + "hg_apps_dashboard.html");
                createLI("Edit an App", constants.HELP_DOCUMENTATION + "hg_edit_apps.html");
                createLI("View Apps", constants.HELP_DOCUMENTATION + "hg_view_apps.html");               
            break;

        } 

        $("#QH_dashVideo").off().on("click", () => {
            this.dashboardVideo = util.newDashboardModal('#quick-help-center-modal-video', {title: 'Get to Know the Dashboard', hideTitleBar:false, closeEsc: true, closeFx: this.stopVideoPlaying});
            self.startVideo();
        });       
    }

    bindAppDesignerEvents(){
        $("#QH_TWalk").off().on("click", () => {
            sessionStorage.setItem('appTourTag', '_tWalk');
            TourService.initTour('walkthrough');
        });
        $("#QH_TScratch").off().on("click", () => {
            $("#aForm").trigger("mousedown");//Ensure the selected view is for App
            setTimeout(() => { //Wait for the view to change
                sessionStorage.setItem('appTourTag', '_tScratch');
                TourService.initTour('scratch');
            }, 500);
        });
        $("#QH_CtrlHelp").off().on("click", () => {
            const url = $("#QH_CtrlHelp").data("url");
            window.open(url, "_blank");
        }); 
    }

    bindHelpEvents(){
        $("#QH_CtrlHelp").off().on("click", () => {
            const url = $("#QH_CtrlHelp").data("url");
            window.open(url, "_blank");
        }); 
    }

    buildChatContext() {
        try {
            const parts = [];

            switch (this.type) {
                case 'app': {
                    const model = listService.dashboardLayout.mainPanelView.model;
                    const appName = model.get('formName') || model.get('currentFormName') || '';
                    const kind = listService.mainKind;
                    const modeMap = {
                        'L': 'Layout Designer',
                        'B': 'Behaviors Editor',
                        'W': 'Workflow Editor',
                        'M': 'Mobile Designer'
                    };
                    const mode = modeMap[kind] || 'App Designer';
                    parts.push(`The user is in the ${mode}, editing the app: "${appName}"`);

                    if (kind === 'B') {
                        parts.push('They are configuring behaviors/actions for form objects.');
                    } else if (kind === 'W') {
                        parts.push('They are designing the workflow stages and transitions.');
                    } else if (kind === 'M') {
                        parts.push('They are designing the mobile layout of the app.');
                    } else {
                        parts.push('They are designing the form layout with controls and fields.');
                    }
                    break;
                }
                case 'report': {
                    const model = listService.dashboardLayout.mainPanelView.model;
                    const reportName = model.get('reportName') || '';
                    parts.push(`The user is in the Report Designer, editing the report: "${reportName}"`);
                    parts.push('They are designing report layouts with data grids, charts, and other reporting objects.');
                    break;
                }
                default: {
                    const tab = listService.activeDashboardTab || 'forms';
                    const tabDetails = this.getDashboardTabContext(tab);
                    parts.push(`The user is on the Dashboard, in the ${tabDetails.name} section.`);
                    if (tabDetails.subSection) {
                        parts.push(tabDetails.subSection);
                    }
                    parts.push(tabDetails.description);
                    break;
                }
            }

            return parts.join(' ');
        } catch (e) {
            return 'The user is using PerfectApps';
        }
    }

    getDashboardTabContext(tab) {
        const result = { name: '', subSection: '', description: '' };

        switch (tab) {
            case 'forms': {
                result.name = 'Apps';
                result.description = 'This section shows the list of apps (forms) the user can edit, view, or create. Users can create new apps, edit existing ones, manage permissions, view submitted instances, and access the library of templates.';
                const $active = $('#dashboard-left-panel .bg-success');
                const nodeType = $active.attr('data-nodetype') || '';
                const sectionAttr = $active.find('[section-type]').attr('section-type') ||
                    $active.closest('.document').find('[section-type]').attr('section-type') || '';
                if (nodeType === 'editForms' || sectionAttr.includes('EditForms') || nodeType === 'PrivateForms' || nodeType === 'SharedForms') {
                    result.subSection = 'They are browsing their editable apps (Edit Apps).';
                } else if (nodeType === 'viewForms' || sectionAttr.includes('ViewForms')) {
                    result.subSection = 'They are browsing apps they can only view (View Apps).';
                } else if (nodeType === 'library' || sectionAttr.includes('Library')) {
                    result.subSection = 'They are browsing the app library/templates.';
                }
                break;
            }
            case 'reports': {
                result.name = 'Reports';
                result.description = 'This section shows reports. Users can create new reports, edit existing ones, or view report data. Reports pull data from apps and display it in grids, charts, and other visualizations.';
                const $activeR = $('#dashboard-left-panel .bg-success');
                const nodeTypeR = $activeR.attr('data-nodetype') || '';
                const sectionAttrR = $activeR.find('[section-type]').attr('section-type') ||
                    $activeR.closest('.document').find('[section-type]').attr('section-type') || '';
                if (nodeTypeR === 'editReports' || sectionAttrR.includes('EditReports')) {
                    result.subSection = 'They are browsing their editable reports.';
                } else if (nodeTypeR === 'viewReports' || sectionAttrR.includes('ViewReports')) {
                    result.subSection = 'They are browsing reports they can only view.';
                }
                break;
            }
            case 'notifications': {
                result.name = 'Notifications';
                result.description = 'This section shows notification status: items needing attention, completed notifications, and failed notifications.';
                break;
            }
            case 'connections': {
                result.name = 'Connections';
                result.description = 'This section manages external data connections. Available connection types: Databases, Directory Services (LDAP/AD), SOAP Web Services, REST Web Services, Apps (inter-app), Google Sheets, and Text Files.';
                const $activeC = $('#dashboard-left-panel .bg-success');
                const nodeTypeC = $activeC.attr('data-nodetype') || '';
                const sectionAttrC = $activeC.find('[section-type]').attr('section-type') ||
                    $activeC.closest('.document').find('[section-type]').attr('section-type') || '';
                const connectionMap = {
                    'sectionDatabases': 'They are managing Database connections.',
                    'sectionDirectoryServices': 'They are managing Directory Service (LDAP/AD) connections.',
                    'sectionWebServices': 'They are managing SOAP Web Service connections.',
                    'sectionRESTWebServices': 'They are managing REST Web Service connections.'
                };
                if (connectionMap[sectionAttrC]) {
                    result.subSection = connectionMap[sectionAttrC];
                } else if (connectionMap[nodeTypeC]) {
                    result.subSection = connectionMap[nodeTypeC];
                }
                break;
            }
            case 'settings': {
                result.name = 'Settings';
                result.description = 'This section manages account and system settings: Users, User Groups (Resources), Account Details, License, Personal Details, Lists, Email Server, Service URLs, User Positions, and Data Synchronization.';
                const $activeS = $('#dashboard-left-panel .bg-success');
                const nodeTypeS = $activeS.attr('data-nodetype') || '';
                const settingsMap = {
                    'personalDetails': 'They are viewing/editing their Personal Details (name, email, language, password).',
                    'users': 'They are managing Users.',
                    'userGroup': 'They are managing User Groups (Resources).',
                    'settings': 'They are viewing Account Settings.',
                    'license': 'They are viewing License information.',
                    'listGroup': 'They are managing Lists (dropdown options).',
                    'emailGroup': 'They are configuring Email Server settings.',
                    'serviceURLGroup': 'They are managing Service URLs.',
                    'positions': 'They are managing User Positions.',
                    'synchronize': 'They are configuring Data Synchronization.'
                };
                if (settingsMap[nodeTypeS]) {
                    result.subSection = settingsMap[nodeTypeS];
                }
                break;
            }
            default:
                result.name = tab;
                result.description = 'The user is navigating the PerfectApps dashboard.';
        }

        return result;
    }

    generateQuickHelp() {

        $(".qh_links").hide();

        switch (this.type) {
            case 'app':
                this.bindAppDesignerEvents();
                this.bindHelpEvents();
                $("#appDesigner").show();
                break;
            case 'report':
                this.bindHelpEvents();
                $("#reportDesigner").show();
                break;
            default: //dashboard
                this.bindDashboardEvents();
                $("#dashboard").show();
                break;
        }

        this.bindHelpSectionEvents();
    }

    stopVideoPlaying() {
        const videoPlayer = $('.ui-dialog .quick-help-video-player').get(0);
        videoPlayer.pause();
        videoPlayer.currentTime = 0;
        $("#quick-help-center-modal-video").dialog("destroy");
    }

    startVideo() {

        this.dashboardVideo.dialog("open");

        setTimeout(function () {
            const videoPlayer = $('.ui-dialog .quick-help-video-player').get(0);
            videoPlayer.play();
        }, 10);
    }

    createModalBoxes() {        
        this.helpGuide = util.newDashboardModal('#quick-help-center-modal', {title: 'Help Guide and Training Videos', hideTitleBar: false, closeEsc: true});   
    }

    render() {

        util.getURLFromPHPAsync(constants.HELP_VIDEOS + '?id=' + this.videoId)
        .then(videoUrl => {
            this.$el.empty();
            this.$el.html(this.template({ "videoUrl": videoUrl, "title": this.title }));
            this.generateQuickHelp();
            this.enableSlide();
            this.createModalBoxes();
        })
        .catch(error => {
            console.error("Failed to load quick help video:", error);
            this.$el.html(this.template({ "videoUrl": "", "title": this.title }));
        });

        return this;
    }

}

export default QuickHelpView;
